import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  id: '',
  email: '',
  username: '',
  name: '',
  profilePic: '',
  bio: '',
  role: '',       // 'admin' | 'client'
  isOnline: false,
  lastSeen: null,
};

const activeUserSlice = createSlice({
  name: 'activeUser',
  initialState,
  reducers: {
    setActiveUser: (state, { payload }) => {
      state.id         = payload.id         ?? state.id;
      state.email      = payload.email      ?? state.email;
      state.username   = payload.username   ?? state.username;
      state.name       = payload.name       ?? state.name;
      state.profilePic = payload.profilePic ?? state.profilePic;
      state.bio        = payload.bio        ?? state.bio;
      state.role       = payload.role       ?? state.role;
      state.isOnline   = payload.isOnline   ?? state.isOnline;
      state.lastSeen   = payload.lastSeen   ?? state.lastSeen;
    },
    setUserProfile: (state, { payload }) => {
      if (payload.name       !== undefined) state.name       = payload.name;
      if (payload.username   !== undefined) state.username   = payload.username;
      if (payload.bio        !== undefined) state.bio        = payload.bio;
      if (payload.profilePic !== undefined) state.profilePic = payload.profilePic;
    },
    setOnlineStatus: (state, { payload }) => {
      state.isOnline = payload.isOnline;
      state.lastSeen = payload.lastSeen ?? state.lastSeen;
    },
    clearActiveUser: () => initialState,
  },
});

export const {
  setActiveUser,
  setUserProfile,
  setOnlineStatus,
  clearActiveUser,
} = activeUserSlice.actions;

export default activeUserSlice.reducer;
